import { ConstructionProjectFeaturesAccessMap } from '@construction/construction.enums';
import {
  ConstructionProjectFeaturesType,
  ConstructionProjectLoadModel,
  QCScope,
  QCType,
} from '@construction/models/construction-project.model';
import { ElementsPlanDatesWbsConfig } from '@core/services/api/construction-geo-api.service';

/** Union of all state slices owned by the construction-project signal store features. */
export type ConstructionProjectCoreState = {
  project: ConstructionProjectLoadModel;
  lastEventStatus: string | undefined;
  lastDroneImage: string | Date | null;
  features: ConstructionProjectFeaturesType[];
  featurePermission: ConstructionProjectFeaturesAccessMap;
  qcTypes: QCType[];
  qcScopes: QCScope[];
  qcConfigPublished: boolean;
  elementsWithWeights: string[];
  visibleElements: string[];
  elementsPlanDatesWbsConfig: ElementsPlanDatesWbsConfig;
};

/** All feature permissions default to `false` until the store is hydrated via `updateConstructionProjectStore`. */
export const defaultFeaturePermissions: ConstructionProjectFeaturesAccessMap = {
  drone_imagery: false,
  logistics_inventory: false,
  digital_twin: false,
  production_tracking: false,
  equipment_tracking: false,
  omega: false,
  advanced_detection: false,
  qc_issues: false,
  approvals: false,
  mv_circuit: false,
  terafab: false,
  documents: false,
};
